module.exports = __webpack_public_path__ + "img/self_assessment.5fa93bdd.svg";